import { ContractResponseDtoContractStatusEnum } from 'libs/pinnacle-sdk';

export const isCancelledOrNTUContract = (
  contractStatus?: ContractResponseDtoContractStatusEnum
): boolean => {
  return (
    contractStatus === ContractResponseDtoContractStatusEnum.NotTakenUp ||
    contractStatus === ContractResponseDtoContractStatusEnum.Cancelled
  );
};
